export const LayoutGridTwoCols = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div className="grid md:grid-cols-2 gap-12">{children}</div>;
};
